import React from 'react';

import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core';
import { fade } from '@material-ui/core/styles/colorManipulator';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import classnames from 'classnames';

const styles = ({
  spacing: { unit },
  palette: { primary },
  custom: {
    palette: { colorSupportSteel, colorSupportGray, colorSupportSlate, colorAccentAloe, colorAccentWatermelon },
  },
}: Theme) =>
  createStyles({
    root: {
      padding: `${unit / 2}px ${unit}px`,
    },
    inherit: {
      color: 'inherit',
    },
    primary: {
      color: primary.main,
    },
    supportSlate: {
      color: colorSupportSlate,
    },
    default: {
      color: colorSupportSteel,
    },
    defaultIncludeBackground: {
      background: fade(colorSupportSteel, 0.2),
    },
    // TODO unify with theme colors as mockups use colors that we don't have defined
    // https://www.figma.com/file/lWC5H3y5FUdHh3cJg3NLds/Messaging-Activity?node-id=331%3A138
    success: {
      color: colorAccentAloe,
    },
    successIncludeBackground: {
      background: fade(colorAccentAloe, 0.2),
    },
    error: {
      color: colorAccentWatermelon,
    },
    errorIncludeBackground: {
      background: fade(colorAccentWatermelon, 0.2),
    },
    info: {
      color: colorSupportGray,
    },
    supportSteel: {
      color: colorSupportSteel,
    },
    infoIncludeBackground: {
      background: fade(colorSupportGray, 0.2),
    },
    accentAlloe: {
      color: colorAccentAloe,
    },
    accentAlloeIncludeBackground: {
      background: fade(colorAccentAloe, 0.2),
    },
    accentWatermelon: {
      color: colorAccentWatermelon,
    },
    accentWatermelonIncludeBackground: {
      background: fade(colorAccentWatermelon, 0.2),
    },
  });

export interface SvgIconWrapperProps extends Omit<SvgIconProps, 'classes' | 'color'>, WithStyles<typeof styles> {
  Icon: React.ComponentType<SvgIconProps>;
  color?:
    | 'primary'
    | 'supportSlate'
    | 'supportSteel'
    | 'accentAlloe'
    | 'accentWatermelon'
    | 'default'
    | 'success'
    | 'error'
    | 'info'
    | 'inherit';
  includeBackground?: boolean;
}

const SvgIconWrapperComponent: React.FC<SvgIconWrapperProps> = ({
  classes,
  className,
  Icon,
  color = 'default',
  includeBackground,
  ...rest
}) => {
  if (includeBackground) {
    const classNameBackground = classes[`${color}IncludeBackground` as keyof typeof classes];
    return (
      <div className={classnames(classes.root, className, classNameBackground)}>
        <Icon className={classnames(className, classes[color])} {...rest} />
      </div>
    );
  }
  return <Icon className={classnames(className, classes[color])} {...rest} />;
};

export const SvgIconWrapper = withStyles(styles)(SvgIconWrapperComponent);
